import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { BRAND, CONTACT, NAV } from "../lib/site";
import {
  RequestQuoteButton,
  AskExpertButton,
  LeaveReviewButton,
} from "./Buttons";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative border-t border-white/10 bg-bb-bg pt-20 pb-10"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
        <div className="md:col-span-5">
          <img
            src={BRAND.lockup}
            alt="Big Buck Services, LLC"
            className="h-12 w-auto mb-6"
          />
          <p className="text-bb-gold font-cond uppercase tracking-widest text-sm mb-4">
            {BRAND.tagline}
          </p>
          <p className="text-bb-silver/60 max-w-sm leading-relaxed">
            Locally owned, owner-operated oilfield trucking and site services.
            Serving the Delaware/Permian Basin since 2014.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-cond uppercase tracking-widest text-xs text-bb-silver/50 mb-5">
            Explore
          </h4>
          <ul className="space-y-3">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-bb-silver/80 hover:text-bb-gold transition-colors font-cond uppercase tracking-wide text-sm"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-cond uppercase tracking-widest text-xs text-bb-silver/50 mb-5">
            Reach Us
          </h4>
          <ul className="space-y-4 text-bb-silver/80">
            <li className="flex items-start gap-3">
              <MapPin className="h-5 w-5 text-bb-gold shrink-0 mt-0.5" />
              <span>{CONTACT.serviceArea}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-5 w-5 text-bb-gold shrink-0" />
              <a href={`tel:${CONTACT.phone}`} className="hover:text-bb-gold transition-colors">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-5 w-5 text-bb-gold shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-bb-gold transition-colors break-all">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:items-center py-8 border-t border-white/10">
        <RequestQuoteButton testid="footer-request-quote-btn" />
        <AskExpertButton testid="footer-ask-expert-btn" />
        <LeaveReviewButton testid="footer-leave-review-btn" />
      </div>

      <div className="flex flex-col md:flex-row justify-between gap-3 pt-8 text-xs text-bb-silver/40 font-mono2 uppercase tracking-wider">
        <p>© {new Date().getFullYear()} Big Buck Services, LLC. All rights reserved.</p>
        <p>{BRAND.established} · Hagerman, New Mexico</p>
      </div>
    </div>
  </footer>
);
